<template>
  <div>
    <lang-flag
      v-if="isValidIso(value)"
      @click.native="toggleMenu"
      :style="flagStyle"
      :iso="value"
      :squared="false"
    />
    <span
      v-else
      @click="toggleMenu"
      :style="spanStyle"
    >
      {{ formatText(value) }}
    </span>
    <transition name="fade">
      <ul
        :class="{ inverse }"
        v-if="showMenu"
      >
        <li
          v-for="option in filteredOptions"
          @click="input(option)"
          :key="option"
        >
          <lang-flag
            v-if="isValidIso(option)"
            :style="flagStyle"
            :iso="option"
            :squared="false"
          />
          <span
            v-else
            :style="spanStyle"
          >
            {{ formatText(option) }}
          </span>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import LangFlag from 'vue-lang-code-flags'
import langs from '@cospired/i18n-iso-languages'

export default {
  name: 'LocaleDropdown',
  components: {
    LangFlag
  },
  data () {
    return {
      showMenu: false
    }
  },
  props: {
    options: {
      type: Array,
      default: () => { return [] }
    },
    value: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#000'
    },
    height: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isValidIso (locale) {
      return langs.isValid(locale)
    },
    input (option) {
      this.showMenu = false
      this.$emit('input', option)
    },
    toggleMenu () {
      this.showMenu = !this.showMenu
    },
    formatText (str) {
      return str.slice(0, 2).toUpperCase()
    }
  },
  computed: {
    filteredOptions () {
      return this.options.filter(o => o !== this.value)
    },
    spanStyle () {
      return {
        backgroundColor: this.backgroundColor,
        fontSize: this.width / 2 + 'px',
        lineHeight: this.height + 'px',
        width: this.width + 'px',
        height: this.height + 'px'
      }
    },
    flagStyle () {
      return {
        width: this.width + 'px',
        height: this.height + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

div {
  position: relative;
  &:hover {
    cursor: pointer;
  }
}

span {
  display: block;
  text-align: center;
  vertical-align: middle;
}

ul {
  position: absolute;
  left: 0;
  padding: 0;
  margin: 0 0;
  list-style: none;
  text-align: left;
  z-index: z(LocaleDropdown);
}

ul:not(.inverse) {
  top: 100%;
}

ul.inverse {
  bottom: 100%;
}
</style>
